import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check, Copy } from "@phosphor-icons/react";
import { getInstallCommand } from "@/lib/install";

export default function HeroCopyCommand({ testId = "hero-copy-btn" }) {
  const [copied, setCopied] = useState(false);
  const installCommand = getInstallCommand();

  const showCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(installCommand);
    } catch (error) {
      // Clipboard access can be unavailable outside a secure browser context.
    }
    showCopied();
  };

  useEffect(() => {
    const handleInstallCopy = () => showCopied();
    window.addEventListener("windie:install-copy", handleInstallCopy);

    if (new URLSearchParams(window.location.search).get("install") === "1") {
      showCopied();
      window.history.replaceState({}, "", "/#top");
    }

    return () => window.removeEventListener("windie:install-copy", handleInstallCopy);
  }, []);

  return (
    <>
      <div
        className="mx-auto flex w-full max-w-xl items-center justify-between gap-4 rounded-2xl border border-white/50 bg-white/70 py-4 pl-6 pr-4 shadow-[0_8px_32px_rgba(0,0,0,0.05)] backdrop-blur-xl"
        data-testid="hero-curl-box"
      >
        <div className="flex min-w-0 items-center gap-3 overflow-hidden">
          <span className="select-none font-mono text-[#466154]">$</span>
          <code className="truncate font-mono text-sm text-ink md:text-base">
            {installCommand}
          </code>
        </div>
        <button
          onClick={copy}
          aria-label="Copy install command"
          data-testid={testId}
          className="group relative inline-flex h-10 shrink-0 items-center gap-2 rounded-xl bg-ink px-4 text-sm font-medium text-white transition-colors duration-300 hover:bg-ink/90 focus:outline-none focus:ring-2 focus:ring-ink/30 focus:ring-offset-2"
        >
          <AnimatePresence mode="wait" initial={false}>
            {copied ? (
              <motion.span
                key="done"
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
                className="flex items-center gap-2"
              >
                <Check size={15} weight="bold" /> Copied
              </motion.span>
            ) : (
              <motion.span
                key="copy"
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
                className="flex items-center gap-2"
              >
                <Copy size={15} /> Copy
              </motion.span>
            )}
          </AnimatePresence>
        </button>
      </div>
      <p className="mt-4 text-sm text-ink-70">
        One command. Local runtime. Your choice of model.
      </p>
    </>
  );
}
